import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ICuestionario, IFiltroCuestionario} from '@core/models';
import ICuestionarioVinculado from '@core/models/CuestionarioVinculado.interface';
import IOpcionesCuestionario from '@core/models/OpcionesCuestionario.interface';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CuestionarioService {
  private baseUrl = `${environment.serverUrl}Cuestionario/`;

  private baseUrl2 = `${environment.serverUrl}OpcionesCuestionario/`;

  private baseUrl3 = `${environment.serverUrl}CuestionarioVinculado/`;

  constructor(private http: HttpClient) {}

  getCuestionarioByEmpresaId(id: number) {
    return this.http.get(`${this.baseUrl}GetCuestionarioByIdEmpresa/${id}`);
  }
  FiltroCuestionario(body: IFiltroCuestionario) {
    return this.http.post(`${this.baseUrl}FiltroCuestionario`,body);
  }

  postCuestionario(body: ICuestionario) {
    return this.http.post(`${this.baseUrl}`, body);
  }
  putCuestionario(body: ICuestionario) {
    return this.http.put(`${this.baseUrl}${body.Id}`, body);
  }
  deleteCuestionario(Id: number) {
    return this.http.delete(`${this.baseUrl}CuestionarioDelete/${Id}`);
  }



  postBatchOpcionesCuestionario(body: any[]) {
    return this.http.post(`${this.baseUrl2}batch`, body);

  }

  putOpcionesCuestionario(body: any) {
    return this.http.put(`${this.baseUrl2}${body.Id}`, body);

  }
  deleteOpcionesCuestionario(id: any) {
    return this.http.delete(`${this.baseUrl2}${id}`);

  }
  CuestionarioVinculadoDelete(id: any) {
    return this.http.delete(`${this.baseUrl3}CuestionarioVinculadoDelete/${id}`);

  }
  // https://localhost:44370/api/CuestionarioVinculado/CuestionarioVinculadoDelete/4

  postCuestionarioVinculado(body: ICuestionarioVinculado) {
    return this.http.post(`${this.baseUrl3}`, body);
  }

  putCuestionarioVinculado(id :number, body: ICuestionarioVinculado) {
    return this.http.put(`${this.baseUrl3}${id}`, body);
  }

  GetCuestionarioVinculadoByIdCuestionario(id: number) {
    return this.http.get(`${this.baseUrl3}GetCuestionarioVinculadoByIdCuestionario/${id}`);
  }

  // https://localhost:44370/api/CuestionarioVinculado/GetCuestionarioVinculadoByIdCuestionario/19
}
